import { isDefined } from "../../Utils/utils";

const isAmountOne = (amount) => Number(amount) === 1;

export const shouldHidePositionPriceColumns = (documentType) =>
  documentType === "DELIVERYNOTE" ||
  (typeof documentType === "string" &&
    documentType.endsWith("PACKING_LIST"));

export const shouldHidePositionPrices = (documentType, hideGroupPrices = false) =>
  hideGroupPrices || shouldHidePositionPriceColumns(documentType);

export const shouldHidePositionUnitPriceColumn = (
  documentType,
  hidePositionPrices = false
) =>
  hidePositionPrices && !shouldHidePositionPriceColumns(documentType);

export const shouldShowPositionGroupSubtotal = (
  isSummable,
  documentType,
  hidePositionPrices = false
) =>
  Boolean(isSummable) &&
  !shouldHidePositionPrices(documentType, hidePositionPrices);

export const isNegotiableAmountEditable = (position, documentType) =>
  position.negotiable && documentType === "OFFER";

export const parsePositionAmount = (amount) => {
  if (typeof amount === "number") {
    return Number.isFinite(amount) ? amount : Number.NaN;
  }

  if (typeof amount !== "string" || amount.trim() === "") {
    return Number.NaN;
  }

  return Number(amount.trim().replace(",", "."));
};

export const getMinPositionAmount = (min) => {
  const parsedMin = parsePositionAmount(min);
  return parsedMin > 0 ? parsedMin : 1;
};

export const getMaxPositionAmount = (max) => {
  const parsedMax = parsePositionAmount(max);
  return parsedMax > 0 ? parsedMax : undefined;
};

export const clampPositionAmount = (amount, minAmount, maxAmount) => {
  let parsedAmount = parsePositionAmount(amount);

  if (Number.isNaN(parsedAmount)) {
    parsedAmount = minAmount;
  }

  parsedAmount = Math.max(parsedAmount, minAmount);

  if (isDefined(maxAmount)) {
    parsedAmount = Math.min(parsedAmount, maxAmount);
  }

  return parsedAmount;
};

export const shouldHidePositionAmountAndPriceUnit = (
  position,
  documentType
) =>
  !isNegotiableAmountEditable(position, documentType) &&
  isAmountOne(position.amount) &&
  !isDefined(position.unit);

export const shouldAutoSelectOptionalPosition = (
  position,
  amount,
  isSelected
) =>
  position.optional &&
  position.negotiable &&
  Number(amount) > 1 &&
  !isSelected;

export const shouldShowOptionalPositionColumn = (positions) =>
  positions.some(
    (position) => position.type !== "FREE_TEXT" && position.optional
  );

export const shouldHideQuantityAndPriceColumns = (positions, documentType) =>
  positions.length > 0 &&
  positions.every(
    (position) =>
      position.type === "FREE_TEXT" ||
      shouldHidePositionAmountAndPriceUnit(position, documentType)
  );
